import { render, staticRenderFns } from "./HeaderCartComponent.vue?vue&type=template&id=36bb5db8&scoped=true&"
import script from "./HeaderCartComponent.vue?vue&type=script&lang=js&"
export * from "./HeaderCartComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bb5db8",
  null
  
)

export default component.exports